const pad = (value: string | number = '', width = 2, paddingChar = '0') => {
  return value.toString().padStart(width, paddingChar);
};

export default pad;
